import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatIconModule, MatRippleModule, MatTooltipModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { InfoBannerComponent } from './info-banner.component';

@NgModule({
  entryComponents: [
    InfoBannerComponent
  ],
  declarations: [
    InfoBannerComponent
  ],
  imports: [
    CommonModule,
    FuseSharedModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatRippleModule,
    MatTooltipModule,
    TranslateModule
  ],
  exports: [
    InfoBannerComponent
  ]
})
export class InfoBannerModule {}
